import { SearchQuery } from "../code/search-query/search-query";
import {
  buildSearchQuery,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";
import { DataColumn } from "../controls/Data.default";
import { DynamicSchema } from "../controls/DynamicForm.default";

export interface IncidentTypesViewForm {
  readonly name: string;
  readonly description: string;
}

export const incidentTypesViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 192,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    title: "Description",
    key: "description",
    width: 256,
    sort: true,
  },
];

const incidentTypesQueryMappings: QueryFieldMapping[] = [
  { formField: "name" },
  { formField: "description" },
];

export const mapIncidentTypesViewQuery = (
  values: IncidentTypesViewForm,
): SearchQuery => buildSearchQuery(values, incidentTypesQueryMappings);

export const incidentTypesSearchSchema: DynamicSchema = {
  groups: [
    {
      controls: [
        { type: "textbox", name: "name", label: "Name" },
        { type: "textbox", name: "description", label: "Description" },
      ],
    },
  ],
};
